angular.module('unergie.main')
.directive('linkyStatus', () =>
    ({
        restrict: 'E',
        scope: {
            communicating: '=',
            migrated: '=',
            distributorIt: '=',
            metterKind: '=',
            parentContainer: '@',
        },
        templateUrl: '/directives/linkyStatus/linkyStatus.html',
        link(scope, element) {
            scope.isPopoverVisible = false

            scope.getActiveStateClass = function (field) {
                if ((scope[field] === true) || (scope[field] === 'true')) {
                    return 'active'
                } else if ((scope[field] === false) || (scope[field] === 'false')) {
                    return 'inactive'
                }
                return 'unknown'
            }

            const activate = function () {
                const $containerElement = element.closest(scope.parentContainer)
                const mouseWithin = function ($element, mouseX, mouseY) {
                    const pos = $element.offset()
                    const { top } = pos
                    const { left } = pos
                    const height = $element.height()
                    const width = $element.width()
                    return (mouseX >= left) && (mouseY >= top) && (mouseX <= (left + width)) && (mouseY <= (top + height))
                }

                $containerElement.on('mousemove.linkyStatus', (e) => {
                    const isMouseWithin = mouseWithin(element.find('.img-linky'), e.pageX, e.pageY)
                    if (scope.isPopoverVisible !== isMouseWithin) {
                        return scope.$apply(() => {
                            scope.isPopoverVisible = isMouseWithin
                        })
                    }
                })

                return scope.$on('$destroy', () => $containerElement.off('mousemove.linkyStatus'))
            }

            return activate()
        },
    })
)
